<div class="key-benefits">
    <h2 class="key-benefits-title sir-text-style-title-m-default">
        {{ translations()!.previewPage.keyBenefitsTitle | interpolate : { application: application() } }}
    </h2>
    <div class="box-container">
        <ng-template #keyBenefitItems>
            @for (item of benefits(); track $index) {
            <matchmaking-info-box
                data-cy="info-box"
                [imageSrc]="item.imgSrc"
                [title]="getTranslation(item.translationTitleKey)!"
                [description]="getTranslation(item.translationDescriptionKey)!">
            </matchmaking-info-box>
            }
        </ng-template>

        <div class="key-benefits-desktop-view" data-cy="key-benefits-desktop-view">
            <ng-container [ngTemplateOutlet]="keyBenefitItems" />
        </div>
        <sirius-slider class="key-benefits-mobile-view" data-cy="key-benefits-mobile-view">
            <ng-container [ngTemplateOutlet]="keyBenefitItems" />
        </sirius-slider>
    </div>
</div>
